import { render, staticRenderFns } from "./userMsg.vue?vue&type=template&id=ad600a38&scoped=true"
import script from "./userMsg.vue?vue&type=script&lang=js"
export * from "./userMsg.vue?vue&type=script&lang=js"
import style0 from "./userMsg.vue?vue&type=style&index=0&id=ad600a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad600a38",
  null
  
)

export default component.exports